export default __webpack_public_path__ + "static/media/VC.2f3d3128.png";